export default __webpack_public_path__ + "static/media/isabelleH.30cc2506.png";